// Control-plane policies. The registry, the catalog and the tier table belong to the platform
// and are operated by platform staff only; a tenant sees itself through the `workspace`,
// `entitlement` and `catalog` views, which are that tenant's own resources.
import { allOf, always, isMember, isRole, isSelf, not, platformAdmin } from '../policy/rules.js';
export const tenantPolicy = {
    kind: 'tenant',
    scope: 'platform',
    actions: {
        list: platformAdmin,
        create: platformAdmin,
        read: platformAdmin,
        update: platformAdmin,
        offboard: platformAdmin,
        suspend: platformAdmin,
        resume: platformAdmin,
        'change-tier': platformAdmin,
        'adopt-package': platformAdmin,
        'reapply-package': platformAdmin,
        retry: platformAdmin,
    },
};
export const packagePolicy = {
    kind: 'package',
    scope: 'platform',
    actions: {
        list: platformAdmin,
        create: platformAdmin,
        read: platformAdmin,
        update: platformAdmin,
        retire: platformAdmin,
    },
};
export const tierPolicy = {
    kind: 'tier',
    scope: 'platform',
    actions: { list: platformAdmin },
};
export const workspacePolicy = {
    kind: 'workspace',
    scope: 'tenant',
    actions: { read: isMember },
};
export const entitlementPolicy = {
    kind: 'entitlement',
    scope: 'tenant',
    actions: { read: isMember },
};
export const catalogPolicy = {
    kind: 'catalog',
    scope: 'tenant',
    actions: { read: isRole('TenantAdmin') },
};
/** Self-serve signup has no principal. The edge throttles it; the policy is open by design. */
export const signupPolicy = {
    kind: 'signup',
    scope: 'public',
    actions: { create: always, read: always },
};
/** The directory is read before sign-in (slug → cell hostname): public, throttled at the edge. */
export const directoryPolicy = {
    kind: 'directory',
    scope: 'public',
    actions: { read: always },
};
export const cellPolicy = {
    kind: 'cell',
    scope: 'platform',
    actions: { list: platformAdmin },
};
export const productPolicy = {
    kind: 'product',
    scope: 'platform',
    actions: { list: platformAdmin },
};
/** Platform staff manage platform staff; nobody removes themselves. */
export const adminPolicy = {
    kind: 'admin',
    scope: 'platform',
    actions: {
        list: platformAdmin,
        create: platformAdmin,
        read: platformAdmin,
        remove: allOf(platformAdmin, not(isSelf('sub'))),
    },
};
export const menuPolicy = {
    kind: 'menu',
    scope: 'platform',
    actions: { read: platformAdmin },
};
export const meteringPolicy = {
    kind: 'metering',
    scope: 'platform',
    actions: { ingest: platformAdmin, read: platformAdmin },
};
/** What platform staff say to the people of a tenant or cell (ADR in-app-notices-from-staff). */
export const announcementPolicy = {
    kind: 'announcement',
    scope: 'platform',
    actions: { list: platformAdmin, publish: platformAdmin, withdraw: platformAdmin },
};
//# sourceMappingURL=platform.js.map